import React, {useEffect, useRef} from "react";
import PropTypes from "prop-types";
import ReactSlick from "react-slick";
import {createGlobalStyle} from "styled-components";

const CarouselGlobalStyles = createGlobalStyle`
  /* Slider */
  .slick-slider .slick-arrow-inner-stroke {
      stroke: #48e5ff;
  }

  .slick-dots li button:before {
      color: ${({theme}) => theme.colors.grey300} !important;
      font-size: 0.75rem;
  }

  .slick-dots li.slick-active button:before {
      color: black;
  }

  .slick-arrow:before,
  .slick-arrow:after {
      font-size: 3.75rem;
      color: ${({theme}) => theme.colors.universityColor} !important;
      margin-top: 8px;
      opacity: 0.7;
  }

  .slick-arrow:hover,
  .slick-arrow:focus,
  .slick-arrow:active {
      opacity: 1;
  }

  .slick-track {
      display: flex;
  }

  .slick-track:before {
      content: none;
  }

  .slick-slide {
      height: auto;
      display: flex !important;
      justify-content: center;
  }

  .arrowDisabled {
      opacity: 0;
  }

  .rotate > svg {
      transform: rotate(180deg);
      transform-origin: center;
  }
`;

const Carousel = (props) => {
    const ref = useRef();

    // work around to hide non active slide to enforce aria rule.
    // Refer react-slick issue: https://github.com/akiran/react-slick/issues/1535#issuecomment-877776983
    // Tradeoff: this is affecting carousel behavior; there's a blank screen in between transitions.
    // Ref: https://user-images.githubusercontent.com/41619036/188971154-d0a38a1b-b511-47fe-91b8-8f84b3166452.mp4
    const changeCardVisibility = () => {
        if (ref.current) {
            Array.from(document.querySelectorAll(".slick-slide")).forEach((slide) => {
                slide.style.visibility = slide.classList?.contains("slick-active")
                    ? "visible"
                    : "hidden";
            });
        }
    };

    useEffect(() => {
        changeCardVisibility();
    });

    return (
        <>
            <CarouselGlobalStyles />
            <ReactSlick
                ref={ref}
                dots={props.dots}
                arrows={props.arrows}
                rows={props.rows}
                autoplay={props.autoplay}
                infinite={props.infinite}
                speed={props.speed}
                slidesToShow={props.slidesToShow}
                slidesToScroll={props.slidesToScroll}
                easing="ease"
                responsive={props.responsive}
                className={props.className}
                afterChange={changeCardVisibility}
            >
                {props.children}
            </ReactSlick>
        </>
    );
};
Carousel.propTypes = {
    dots: PropTypes.bool,
    infinite: PropTypes.bool,
    speed: PropTypes.number,
    slidesToShow: PropTypes.number,
    slidesToScroll: PropTypes.number,
    responsive: PropTypes.arrayOf(
        PropTypes.shape({
            breakpoint: PropTypes.number.isRequired,
            settings: PropTypes.shape({}).isRequired,
        }),
    ),
};

Carousel.defaultProps = {
    dots: true,
    arrows: true,
    rows: 1,
    autoplay: false,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
};

export default Carousel;
